import React from 'react';
import {
	Paper,
	Grid,
	Box,
	Typography,
	Divider,
	Dialog,
	List,
	ListItem,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { useTranslations, ToggleRPC } from 'components/utilities';
import PriceSummaryList from 'components/elements/organisms/PriceSummaryList';
import useBookingDetailsDates from './useBookingDetailsDates';

const BookingDetailsDates = ({ boxPaddings, isDesktop }) => {
	const { t } = useTranslations();

	const {
		total_discounted_gross_price,
		pick_up_date_time,
		base_nett_price,
		drop_off_date,
		total_days,
		booking,
	} = useBookingDetailsDates();

	return (
		<Paper>
			<Box {...boxPaddings}>
				<List>
					<ListItem>
						<Grid container spacing={1} justify="space-between">
							<Grid item xs="auto" md={6}>
								<Typography variant="h5" color="primary">
									{t('booking.pickUpDate')}
								</Typography>
								<Typography>{pick_up_date_time}</Typography>
							</Grid>
							<Grid item xs="auto" md={6}>
								<Typography variant="h5" color="primary">
									{t('booking.dropOffDate')}
								</Typography>
								<Typography>{drop_off_date}</Typography>
							</Grid>
						</Grid>
					</ListItem>

					<Divider />

					<ToggleRPC>
						{({ on, toggle }) => (
							<>
								<Dialog open={on} onClose={toggle} fullWidth maxWidth="sm">
									<PriceSummaryList data={booking} />
								</Dialog>
								<ListItem button onClick={toggle}>
									<Grid
										container
										spacing={1}
										justify="space-between"
										alignItems="center"
									>
										<Grid item xs="auto">
											<Typography>
												{t('booking.cost', {
													base_nett_price,
													total_days,
												})}
											</Typography>
											<Typography variant="h2" component="span">
												{total_discounted_gross_price}
											</Typography>{' '}
											{t('common.sar')}
										</Grid>
										<Grid item xs="auto">
											<SearchIcon fontSize={isDesktop ? 'large' : 'default'} />
										</Grid>
									</Grid>
								</ListItem>
							</>
						)}
					</ToggleRPC>
				</List>
			</Box>
		</Paper>
	);
};

export default BookingDetailsDates;
